const logoMicroSoft = new URL('../../assets/sponsors/Microsoft.png', import.meta.url) + '';
const logoBBD = new URL('../../assets/sponsors/BBD.png', import.meta.url) + '';
const logoGDG = new URL('../../assets/sponsors/GDG.png', import.meta.url) + '';

export default [
    { title: 'BBD', img: logoMicroSoft },
    { title: 'MicroSoft', img: logoBBD },
    { title: 'GDG', img: logoGDG }
];
